import React from 'react';
import CommitteeSection from '../components/committee/CommitteeSection';
import useCsvMembers from '../hooks/useCsvMembers';
import './CommitteePages.css';


const InternationalAdvisoryCommitteePage = () => {
  const members = useCsvMembers('/data/international_advisory_committee.csv');
  return (
    <CommitteeSection heading="International Advisory Committee" members={members} />
  );
};

export default InternationalAdvisoryCommitteePage;
